import { Box } from '@rbilabs/universal-components';

export const OfferPictureContainer = Box.withConfig({
  width: {
    base: '4/5',
    md: '70%',
  },
  maxWidth: '550px',
  height: 0,
  paddingBottom: {
    base: '35%',
    md: '30%',
  },
  marginBottom: '2.5',
  marginTop: {
    base: '9',
    md: '20',
  },
});
